import Vue from 'vue'
import App from './App.vue'
import './quasar'
import store from './store'
import router from './router'
import * as AmplifyModules from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import axios from 'axios';

const identityPoolId = process.env.VUE_APP_ENV === 'development' ? 'eu-west-2:90665a80-9872-4e94-9e75-8e88eb205823' : 'eu-west-2:1d94f844-702e-4e8e-ab50-1c47ea1dbfba';
const region = process.env.VUE_APP_ENV === 'development' ? 'eu-west-2' : 'eu-west-2';
const userPoolId = process.env.VUE_APP_ENV === 'development' ? 'eu-west-2_wcJswdOqd' : 'eu-west-2_a29LSprXf';
const userPoolWebClientId = process.env.VUE_APP_ENV === 'development' ? '3s7sq4mrun08afojduep6i4n10' : '56784v5t5tfeknm0ccg2dbbur';

Amplify.configure({
    Auth: {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: identityPoolId,
        // Amazon Cognito Region
        region: region,
        // Amazon Cognito Federated Identity Pool Region 
        // Required only if it's different from Amazon Cognito Region
        identityPoolRegion: region,
        // Amazon Cognito User Pool ID
        userPoolId: userPoolId,
        // Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: userPoolWebClientId,
        // Client Secret - Not supported by SKD currently
        // userPoolWebClientSecret:'1ma6bnuqrm2v2ra8p1qtq6qlqors9pj6ekcjff51n0aql392f6eb'

    }
});


async function getCurrentUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();

      return user ? user.attributes.email : null;  // Adjust to the user attribute you want to track
    } catch (error) {
      console.error('Error retrieving user information:', error);
      return null;
    }
  }

async function recordPageVisit(pagePath) {
    try {
      const username = await getCurrentUser();  // Get logged-in user's info
      const token = store.getters.getCognitoJwtToken;

      axios.post('/api/track-page-visit', {
        page: pagePath,
        timestamp: new Date().toISOString(),
        username: username ,
        token: token
      }).catch(error => {
        console.error('Error recording page visit:', error);
      });
    } catch (error) {
      console.error('Error recording page visit:', error);
    }
  }

// Vue Router Navigation Guard to track page visits
router.beforeEach((to, from, next) => {
    // Track page visit
    recordPageVisit(to.fullPath);
  
    // Continue to the next page
    next();
  });

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.productionTip = false

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')